import { emitEvent } from './emitEvent';
import { getActivityFeed } from './getActivityFeed';
import { getPointSummary } from './getPointSummary';
import { prepareGoalProgress } from './prepareGoalProgress';
import { prepareAchivementCard } from './prepareAchievementCard';
import { getAchievementProgress } from './getAchievementProgress';
import { getUnlockedAchievements } from './getUnlockedAchievements';
import { getNotificationDotStatus } from './getNotificationDotStatus';

interface IGamification {
  emitEvent: typeof emitEvent;
  getActivityFeed: typeof getActivityFeed;
  getPointSummary: typeof getPointSummary;
  prepareGoalProgress: typeof prepareGoalProgress;
  prepareAchivementCard: typeof prepareAchivementCard;
  getAchievementProgress: typeof getAchievementProgress;
  getUnlockedAchievements: typeof getUnlockedAchievements;
  getNotificationDotStatus: typeof getNotificationDotStatus;
}

/**
 * @namespace
 */
const Gamification: IGamification = {
  emitEvent,
  getActivityFeed,
  getPointSummary,
  prepareGoalProgress,
  prepareAchivementCard,
  getAchievementProgress,
  getUnlockedAchievements,
  getNotificationDotStatus,
};

export default Gamification;
